import { RouteObject, useRoutes } from 'react-router-dom';
import { PageNotFound } from '@leagueplatform/web-common-components';
// Import init-route-overrides before route definitions to apply overrides
import './init-route-overrides';
import { RedirectRoutes } from '@highmark-web/highmark-common';
import { PublicRoutes } from './public-routes';
import { ProtectedRoutesLayout } from './protected-routes-layout';
import { StandaloneRoutes } from './standalone-routes';
import { EngenSDKRoutes } from './engen-sdk-routes';
import { LeagueSDKRoutes } from './league-sdk-routes';

const routes: RouteObject[] = [
  ...PublicRoutes,
  {
    path: '/',
    element: <ProtectedRoutesLayout />,
    children: [
      ...RedirectRoutes,
      ...EngenSDKRoutes,
      ...LeagueSDKRoutes,
      ...StandaloneRoutes,
      { path: '*', element: <PageNotFound /> },
    ],
  },
];

export const AppRoutes = () => useRoutes(routes);
